import { render, staticRenderFns } from "./InHospitalDialog.vue?vue&type=template&id=2f5ddce8&scoped=true&"
import script from "./InHospitalDialog.vue?vue&type=script&lang=js&"
export * from "./InHospitalDialog.vue?vue&type=script&lang=js&"
import style0 from "./InHospitalDialog.vue?vue&type=style&index=0&lang=less&"
import style1 from "./InHospitalDialog.vue?vue&type=style&index=1&id=2f5ddce8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5ddce8",
  null
  
)

export default component.exports